import { VpnKey } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import LoginCoverImg from "images/phoenix.gif";
import { PasswordLoginForm } from "pages/Login";

const showLocalPasswordLogin = process.env.NODE_ENV === "development";

export default function LoginSso() {
  const oktaButton = (
    <Button
      variant="outlined"
      size="large"
      fullWidth={showLocalPasswordLogin}
      startIcon={<VpnKey />}
      component="a"
      href={`${process.env.REACT_APP_SSO_URL}`}
    >
      Login with Okta
    </Button>
  );

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", display: "grid", placeItems: "center", background: "black" }}>
      <Box>
        <img
          src={LoginCoverImg}
          alt="login cover"
          style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}
        />

        <Typography
          variant="h4"
          sx={{ textAlign: "center", mt: 3, fontWeight: "bold", color: "white", fontFamily: "monospace" }}
        >
          Phoenix
        </Typography>

        <Typography
          sx={{
            textAlign: "center",
            fontFamily: "monospace",
            color: "white",
            mt: 3,
          }}
        >
          <Box>Providing the world access to a computer.</Box>
          <Box>Ensuring hardware reaches its full lifecycle.</Box>
          <Box>Making enterprise hardware lifecycle management easier.</Box>
        </Typography>

        {showLocalPasswordLogin ? (
          <Box sx={{ maxWidth: "450px", mx: "auto", mt: 3 }}>
            <PasswordLoginForm>{oktaButton}</PasswordLoginForm>
          </Box>
        ) : (
          <Box sx={{ textAlign: "center" }} mt={3}>
            {oktaButton}
          </Box>
        )}
      </Box>
    </Box>
  );
}
